// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sp-5";
export var filledCircle = "_sp-4";
export var historyEntry = "_sp-3";
export var messageSideLeft = "_sp-1";
export var messageSideRight = "_sp-2";
export var orderTrackingCarouselWrapper = "_sp-6";
export var orderTrackingInfoContainer = "_sp-0";